<template>
	<div>

		<BookIcStatic
			v-if="!CanPatientChooseIcSlot"
			:NutritionistProfile="NutritionistProfile"
		/>

		<BookDynamicIcOrVn
			v-if="CanPatientChooseIcSlot"
			:NoAvailableSlotsFound="NoAvailableSlotsFound"
			:NutritionistProfile="NutritionistProfile"
			@bookingCreated="$emit('bookingCreated', $event)"
			:bookingTypeId="BookingTypeId"
		/>
	</div>
</template>
<script>
import BookIcStatic from "@/views/Patients/components/BookIcStatic.vue";
import BookDynamicIcOrVn from "@/views/Patients/components/BookDynamicIcOrVn.vue";
import { BookingTypesEnum } from "@/components/NutriYou/nutriYouBookingTypesEnum";
import CrudClient from "@/services/CrudClient";

export default {
	components: {
		BookDynamicIcOrVn,
		BookIcStatic
	},
	props: {
		PatientProfile: { type: Object, required: true },
		NutritionistProfile: { type: Object, required: true },
	},
	data() {
		return {
			IsCalendarSlotsAvailable: false,
			NoAvailableSlotsFound: false,
			BookingTypeId: BookingTypesEnum.FREE
		}
	},
	created() {
		// this.CurrentPatientProfileService = new CrudClient(
		// 	"CurrentPatient/Profile"
		// );
		// this.BookingsService = new CrudClient("CurrentPatient/Bookings");
		this.CurrentPatientNutritionistService = new CrudClient(
			"CurrentPatient/Nutritionist"
		);

		this.AvailableSlotsService = new CrudClient("CurrentPatient/AvailableSlots");
	},
	async mounted() {
		const res = await this.CurrentPatientNutritionistService.Get(
			"IsCalendarSlotsAvailable"
		);
		this.IsCalendarSlotsAvailable = res.CalendarSlotsAvailable;

		const url = this.BookingTypeId === BookingTypesEnum.FREE ? "GetSlotsForIntroductionVisit" : "GetSlotsForPaidVisit";

		const slotsRes = await this.AvailableSlotsService.Get(null, url);
		if (this.isResultEmpty(slotsRes)) {
			this.NoAvailableSlotsFound = true;
		}
	},
	computed: {
		CalendarSlotsAvailable() {
			return this.IsCalendarSlotsAvailable && !this.NoAvailableSlotsFound;
		},

		CanPatientChooseIcSlot() {
			return (
				this.CalendarSlotsAvailable &&
				!this.PatientProfile?.HasLateCancelledIc
			);
		}
	},
	methods: {
		isResultEmpty(obj) {
			// Filter out Vue's default reactive property (__ob__) and check for other keys
			return Object.keys(obj).filter(key => key !== "__ob__").length === 0;
		},
	}
};
</script>
